import useSWR from 'swr';

export interface User {
  id: number;
  email: string;
  name: string | null;
  role: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  emailVerified: Date | null;
  isAdmin?: boolean;
}

const fetcher = (url: string) => fetch(url, { credentials: 'include' }).then((res) => res.json());

export function useUser() {
  const { data, error, isLoading, mutate } = useSWR<User | null>('/api/user', fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

  return {
    user: data,
    isLoading,
    error,
    mutate,
  };
}

